import { HubConnectionBuilder, LogLevel } from '@aspnet/signalr'

export default {
  install (Vue, store) {
    var token = axios.defaults.headers.common['Authorization']  
    var url='https://tracking.napconational.com/api/hubs/driverHub'  
    //var url = 'https://napcotrucktracking.azurewebsites.net/api/hubs/driverHub' 
    //var url = 'https://localhost:44370/hubs/driverHub' 
    
    const connection = new HubConnectionBuilder()
      .withUrl(url, { accessTokenFactory: () => `${token}` })
      .configureLogging(LogLevel.Information)
      .build()
 
      let startedPromise = null
      function start () {
        token = store.state.users.user.token
        startedPromise = connection.start().catch(err => {
          console.error('Failed to connect with hub', err)
          return new Promise((resolve, reject) => 
            setTimeout(() => start().then(resolve).catch(reject), 5000))
        })
        return startedPromise
      }
      connection.onclose(() => start())
       
      start()

    var driverHub = new Vue()
    // every component will use this.$driverHub to access the event bus
    Vue.prototype.$driverHub = driverHub
    // Forward server side SignalR events through $driverHub, where components will listen to them
    connection.on('ReceiveMessage', (user , message, lat, lng) => {
      driverHub.$emit('driverMessageReceived', { user, message, lat, lng })
    })
    connection.on('cms_new_waybill', ()=>{
      console.log('new waybill created')
      driverHub.$emit('cms_new_waybill')
    })
    connection.on('cms_active_waybill',()=>{
      driverHub.$emit('cms_active_waybill')
    })
  }
}